export default {
  finalize() {
    const $ = window.jQuery;
    $('.fancybox').fancybox({
      helpers: {
        media: true,
      },
      youtube: {
        autoplay: 1,
        rel: 0,
        showinfo: 0,
        modestbranding: 0,
      },
      wrapCSS: 'is-fullscreen',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/successStories.js